module.exports = __webpack_public_path__ + "img/weixin.457493e3.svg";